import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getRecapLabels, formatFecha } from '../utils/convocatoriaRecap';

// ──────────────────────────────────────────────────────────────────────────
// Paso 5 — Resumen (mockup compartido por Jody, 26/08/2026).
//
// A diferencia de los pasos 3 y 4, aquí NO se repite la fila de RecapField —
// en su lugar es una tarjeta centrada (ícono + título + texto explicativo +
// tabla label/valor de todo lo configurado + aviso de que se enviarán correos
// automáticos al publicar), calcada de la estructura del mockup. Los valores
// vienen de los mismos helpers (`getRecapLabels`/`formatFecha`) que usan los
// pasos 3 y 4, para no duplicar el mapeo de ids a etiquetas.
//
// El footer de este paso (Enviar correo prueba / Guardar Borrador / Cancelar /
// Publicar convocatoria) se arma en NuevaConvocatoriaMasivo.jsx — no aquí —
// porque el resto del wizard ya centraliza el footer en el componente padre.
// Sin backend todavía: "Enviar correo prueba" y "Publicar convocatoria" son
// placeholders (`console.log` + TODO).
// ──────────────────────────────────────────────────────────────────────────

const ResumenStep = ({ formValues, tipoProcesoOptions, cargoOptions, regionOptions, sedeOptions }) => {
    const { convocatoriaLabel, tipoLabel, cargoLabel, regionesLabel, sedesLabel } = getRecapLabels(formValues, {
        tipoProcesoOptions, cargoOptions, regionOptions, sedeOptions
    });
    const fechaInicioLabel = formatFecha(formValues.FechaHoraInicio);
    const fechaFinLabel = formatFecha(formValues.FechaHoraFin);

    return (
        <div className="d-flex justify-content-center py-3">
            <div className="text-center" style={{ maxWidth: "560px", width: "100%" }}>
                <div className="d-flex justify-content-center">
                    <div style={{
                        width: "56px", height: "56px", borderRadius: "50%",
                        backgroundColor: "#e2f6e9", display: "flex", alignItems: "center", justifyContent: "center"
                    }}>
                        <FontAwesomeIcon icon="clipboard-check" size="lg" style={{ color: "#8DBA38" }} />
                    </div>
                </div>

                <h5 className="font-weight-bold mt-3">Resumen del proceso</h5>
                <p className="text-muted">
                    Revise la configuración antes de publicar. Al publicar, se notificará por correo corporativo
                    a toda la población objetivo y la convocatoria quedará habilitada en Intranet.
                </p>

                <div className="text-left" style={{ border: "1px solid #dee2e6", borderRadius: "8px", padding: "16px 20px" }}>
                    <ResumenRow label="Nombre" value={convocatoriaLabel || "(sin nombre)"} />
                    <ResumenRow label="Tipo" value={tipoLabel} />
                    <ResumenRow label="Fecha inicio" value={fechaInicioLabel} />
                    <ResumenRow label="Fecha cierre" value={fechaFinLabel} />
                    <ResumenRow label="Cargo" value={cargoLabel} />
                    <ResumenRow label="Regiones" value={regionesLabel || "Todas"} />
                    <ResumenRow label="Sedes" value={sedesLabel || "(ninguna)"} isLast />
                </div>

                <div className="d-flex align-items-start mt-3" style={{
                    backgroundColor: "#fff8e6", border: "1px solid #ffe69c", borderRadius: "8px", padding: "12px 16px", gap: "10px"
                }}>
                    <FontAwesomeIcon icon="exclamation-circle" style={{ color: "#997404", marginTop: "2px" }} />
                    <span style={{ fontSize: "0.9em", color: "#664d03" }}>
                        Esta acción enviará correos automáticos a {cargoLabel || "la población objetivo"} con acceso a la convocatoria.
                    </span>
                </div>
            </div>
        </div>
    )
}

export default ResumenStep

const ResumenRow = ({ label, value, isLast }) => (
    <div className="d-flex justify-content-between" style={{ padding: "8px 0", borderBottom: isLast ? "none" : "1px solid #eee" }}>
        <span className="text-muted">{label}</span>
        <span className="font-weight-bold">{value ?? "-"}</span>
    </div>
)
